import { render, staticRenderFns } from "./TableCellVehicleType.vue?vue&type=template&id=2dc75a88&"
import script from "./TableCellVehicleType.vue?vue&type=script&lang=ts&"
export * from "./TableCellVehicleType.vue?vue&type=script&lang=ts&"
import style0 from "./TableCellVehicleType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports